import { Button } from '@material-ui/core';
import React, { FC, useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Auth0LockContext, { isAuthenticated } from 'Auth0LockContext';
import backgroundImage from './BaseLayout.backImage.png';
import HomeButtonImg from './BaseLayout.homeButton.png';

// StoryBookからも読み込むためexport
export const GlobalCSS = styled.div`
  font-size: 16px;
  font-family: 'Noto Sans JP', sans-serif;
  line-height: 1.5;
  color: #333;

  a {
    text-decoration: none;
  }

  a:hover {
    opacity: 0.5;
    transition: 0.5s;
  }

  h2 {
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
    color: #231815;
    border-bottom: 5px solid #c69e61;
    padding-bottom: 10px;
    margin-bottom: 20px;

    @media screen and (max-width: 751px) {
       {
        font-size: 1.2rem;
      }
    }
  }

  p {
    line-height: 1.2rem;
  }

  @media screen and (max-width: 751px) {
     {
      font-size: 14px;
    }
  }
`;

const Wrap = styled.div`
  background-image: url(${backgroundImage});
  background-position-x: center;
  background-position-y: top;
  background-repeat-x: repeat;
  background-repeat-y: repeat;
  min-height: 100vh;
`;

const Container = styled.div`
  box-sizing: border-box;
  width: 96%;
  max-width: 1095px;
  margin: 0px auto;
`;

const StyledHeader = styled.header`
  padding: 10px;
  text-align: center;
`;

const StyledHomeButton = styled.img`
  max-width: 270px;
  width: 100%;
  height: auto;
`;

const Section = styled.div`
  background: #f2ebc9;
  padding: 20px;
  @media screen and (max-width: 751px) {
    padding: 10px;
  }
`;

const InnerBorder = styled.div`
  background: #fff;
  max-width: 1095px;
  margin: 20px auto 20px;
  border: 10px solid #c69e61;
  padding: 20px;

  @media screen and (max-width: 751px) {
     {
      padding: 10px;
    }
  }
`;

const StyledFooter = styled.footer`
  background: #ac723e;
  padding: 40px 20px 20px 20px;

  ul li {
    margin-bottom: 10px;
  }

  a {
    color: #fff;
    text-decoration: none;
  }

  a:hover {
    opacity: 0.5;
    transition: 0.5s;
  }
`;

/**
 * ベースとなるレイアウトを提供するコンポーネント
 */
const BaseLayout: FC = ({ children }) => {
  const auth0Lock = useContext(Auth0LockContext);

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    auth0Lock.client.logout({
      returnTo: `${window.location.protocol}//${window.location.host}`,
    });
  };

  return (
    <GlobalCSS>
      <Wrap>
        <Container>
          <StyledHeader>
            <Link to="/">
              <StyledHomeButton src={HomeButtonImg} alt="ホームボタン" />
            </Link>
            {auth0Lock.isAuth || isAuthenticated() ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => logout()}
              >
                ログアウト
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  auth0Lock.client.show();
                }}
              >
                ログイン
              </Button>
            )}
          </StyledHeader>
          <Section>
            <InnerBorder>{children}</InnerBorder>
          </Section>
          <StyledFooter>
            <ul>
              <li>
                <Link to="/QandA">購入をお考えの方へ</Link>
              </li>
              <li>
                <Link to="/Termsofuse">利用規約</Link>
              </li>
              <li>
                <Link to="/Environment">動作環境について</Link>
              </li>
              <li>
                <Link to="/Commercial">特定商取引に関する法律に基づく表記</Link>
              </li>
              <li>
                <Link to="/Copyright">著作権について</Link>
              </li>
              <li>
                <Link to="/PrivacyPolicy">プライバシーポリシー</Link>
              </li>
              <li>
                <Link to="/Company">運営会社について</Link>
              </li>
            </ul>
          </StyledFooter>
        </Container>
      </Wrap>
    </GlobalCSS>
  );
};

export default BaseLayout;
